export const DEFAULT_INVENTORY_STATUS_KEYS = Object.freeze(["available"]);

const canonicalStatusToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

export const normalizeInventoryStatusKey = (value) =>
  String(value || "").trim().toLowerCase();

export const normalizeInventoryStatusKeys = (
  value,
  fallback = DEFAULT_INVENTORY_STATUS_KEYS
) => {
  const source = Array.isArray(value) ? value : [];
  const seen = new Set();
  const normalized = [];

  source.forEach((entry) => {
    const key = normalizeInventoryStatusKey(entry);
    if (!key || seen.has(key)) return;
    seen.add(key);
    normalized.push(key);
  });

  if (normalized.length) return normalized;
  if (fallback === null) return [];
  return normalizeInventoryStatusKeys(fallback, null);
};

export const hasExplicitInventoryStatusSelection = (block) =>
  Array.isArray(block?.inventoryStatusKeys) && block.inventoryStatusKeys.length > 0;

const getInventoryStatusCandidates = (item = {}) => {
  const vehicleStatus = item?.inventory_vehicle?.vehicle_status || {};
  const publicDetail = item?.public_detail || {};
  const general = item?.general_detail || {};

  return [
    item.statusKey,
    item.status_key,
    publicDetail.statusKey,
    publicDetail.status_key,
    vehicleStatus.status_key,
    item.statusName,
    item.status,
    publicDetail.status,
    vehicleStatus.status_name,
    general.status,
  ].filter(Boolean);
};

export const inventoryMatchesStatusKeys = (item, statusKeys) => {
  const selected = normalizeInventoryStatusKeys(statusKeys, null);
  if (!selected.length) return false;

  const selectedTokens = new Set(selected.map(canonicalStatusToken).filter(Boolean));
  return getInventoryStatusCandidates(item).some((candidate) =>
    selectedTokens.has(canonicalStatusToken(candidate))
  );
};

export const filterInventoryByStatusKeys = (items, statusKeys) => {
  const source = Array.isArray(items) ? items : [];
  return source.filter((item) => inventoryMatchesStatusKeys(item, statusKeys));
};
